import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PlatformService } from '../services/platform/platform.service';
import { AuthenticationService } from '../services/authentication/authentication.service';

export const platformGuard: CanActivateFn = () => {
  const router = inject(Router);
  const platformService = inject(PlatformService);
  const authenticationService = inject(AuthenticationService);

  const user = authenticationService.currentUser();
  if (!user) {
    router.navigate([platformService.isMobile() ? '/onboarding/welcome' : '/welcome']);
    return false;
  }

  return router.createUrlTree([user.hasTransactions ? '/my-shares' : '/home']);
};
